<template>
  <div>
    <div class="vx-row mb-6">
      <div class="vx-col md:w-1/2 w-full">
        <div class="vx-row mb-6" v-if="showCreationDate">
          <div class="vx-col md:w-1/3 w-full">
            <span class="font-semibold">{{
              $t('creation_date') | capitalize
            }}</span>
          </div>
          <div class="vx-col md:w-2/3 w-full">
            <vs-input class="w-full" v-model="this.date" disabled />
          </div>
        </div>
        <div class="vx-row mb-6" v-if="showCheckbox">
          <div class="vx-col md:w-1/3 w-full">
            <span class="font-semibold"
              >{{ $t('is_review_at_origin') | capitalize }}</span
            >
          </div>
          <div class="vx-col md:w-2/3 w-full">
            <vs-checkbox
              class="inline-flex"
              v-model="isReviewAtOrigin"
              @input="handleChange"
            ></vs-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row mt-6">
      <div class="vx-col w-full">
        <import-invoice :onSuccess="loadDataInTable" :disabled="disabled" v-show="showUploadFile"/>
      </div>
    </div>
    <div v-for="(table, i) in tables" :key="i">
      <vs-divider color="danger" v-if="i !== 0" class="my-6 f-14 f-bold" />
      <div class="vx-row ">
        <div class="vx-col w-full">
          <vs-table stripe search :data="table.tableData">
            <template slot="header">
              <h4>
                  <feather-icon
                    @click="deleteItem(i)"
                    icon="MinusSquareIcon"
                    svgClasses="h-5 w-5 text-danger cursor-pointer "
                  />
                {{ table.fileName }}
              </h4>
            </template>

            <template slot="thead">
              <vs-th
                :sort-key="heading"
                v-for="heading in table.header"
                :key="heading"
                >{{ heading }}</vs-th
              >
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td
                  :data="col"
                  v-for="(col, indexcol) in data[indextr]"
                  :key="indexcol + col"
                >
                  {{ col }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImportInvoice from '@/views/components/files/ImportInvoice'
export default {
  props:{
    showCheckbox:{
      type:Boolean,
      default:true
    },
    disabled:{
      type:Boolean,
      default:false
    },
    showUploadFile:{
      type:Boolean,
      default:true
    },
    showCreationDate:{
      type:Boolean,
      default:true
    }
  },
  components: {
    ImportInvoice
  },
  data () {
    return {
      date: null,
      isReviewAtOrigin: false,
      tables: []
    }
  },
  mounted () {
    this.date = this.formatDate(new Date())
  },
  methods: {
    loadDataInTable ({ results, headers, meta, json }) {
      const newTable = {
        tableData: results,
        header: headers,
        fileName: meta.fileName,
        json
      }
      this.tables.push(newTable)
      this.handleChange()
    },
    deleteItem (i) {
      this.tables.splice(i, 1)
      this.handleChange()
      this.$emit('deleteItem')
    },
    handleChange () {;
      this.$emit('input', {
        date:this.date,
        isReviewAtOrigin: this.isReviewAtOrigin,
        tables: this.tables
      })
    }
  }
}
</script>
